import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { AuthGate } from './AuthGate';
import { App } from './App';
import './styles.css';

const root = document.getElementById('root');
if (!root) throw new Error('Dashboard root element is missing');

createRoot(root).render(
  <StrictMode>
    <AuthGate><App /></AuthGate>
  </StrictMode>,
);

